
import React from 'react';
import { BlogPost } from '@/components/blog/types';
import Hero from '@/components/Hero';
import BlogBreadcrumb from '@/components/blog/BlogBreadcrumb';
import BlogPostDetail from '@/components/blog/BlogPostDetail';

interface BlogDetailViewProps {
  post: BlogPost;
  onBackClick: () => void;
  relatedPosts: BlogPost[];
}

const BlogDetailView: React.FC<BlogDetailViewProps> = ({ post, onBackClick, relatedPosts }) => {
  if (!post) return null;
  
  return (
    <>
      <Hero
        title={post.title}
        subtitle={post.excerpt}
        backgroundImage={post.image}
        height="medium"
        imageStyle="darken"
        contentPosition="center"
        imagePosition="center"
      >
        {post.category && (
          <span className="inline-block bg-[#F97316]/90 text-white px-3 py-1 rounded-full text-sm font-medium mb-4 mt-8">
            {post.category}
          </span>
        )}
        {post.date && (
          <div className="text-white/80 text-sm mt-4">
            <time dateTime={post.date}>{post.date}</time>
          </div>
        )}
      </Hero>
      <div className="bg-[#FDF6ED] py-4">
        <div className="container mx-auto">
          <BlogBreadcrumb title={post.title} category={post.category || ''} />
        </div>
      </div>
      <div className="bg-[#FDF6ED] py-8">
        <div className="container mx-auto px-4 animate-fadeIn transition-opacity duration-500">
          <article>
            <h1 className="text-3xl md:text-4xl font-montserrat font-bold mb-8 text-primary">
              {post.title}
            </h1>
            <BlogPostDetail
              post={post}
              onBackClick={onBackClick}
              relatedPosts={relatedPosts}
            />
          </article>
        </div>
      </div>
    </>
  );
};

export default BlogDetailView;
